import { ApiResponseError } from '@/api/ApiResponseError';

export const readRegionalHighlightPurchaseErrorStatusCode = (
  error: unknown,
): number | undefined => {
  if (error instanceof ApiResponseError) {
    return error.statusCode;
  }
  if (typeof error === 'object' && error !== null && 'statusCode' in error) {
    const statusCode = Number((error as { statusCode: unknown }).statusCode);
    return Number.isFinite(statusCode) ? statusCode : undefined;
  }
  return undefined;
};

export const resolveRegionalHighlightPurchaseConfirmErrorMessage = (
  error: unknown,
  messages: { districtSoldOut: string; generic: string },
): string => {
  if (readRegionalHighlightPurchaseErrorStatusCode(error) === 409) {
    return messages.districtSoldOut;
  }
  return messages.generic;
};
